import { render, staticRenderFns } from "./ResumeItemHeader.vue?vue&type=template&id=60161e91&scoped=true&"
import script from "./ResumeItemHeader.vue?vue&type=script&lang=js&"
export * from "./ResumeItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60161e91",
  null
  
)

export default component.exports